module.exports = __webpack_public_path__ + "static/media/google-brands.da3a9ed4.svg";